const offerInfo = ({ production_year = '', mileage = '', part_kind = '', part_producer = '' }) =>
    [mileage ? `${mileage} km` : '',
        production_year ? `${production_year} R.` : '',
        part_kind,
        part_producer]
    .filter(Boolean)
    .join(' | ')

export default offerInfo